/** ISO 3166-1 alpha-2. Names come from Intl.DisplayNames in Dutch. */
export const ISO_COUNTRIES = (
  'AD AE AF AG AI AL AM AO AQ AR AS AT AU AW AX AZ BA BB BD BE BF BG BH BI BJ BL BM BN BO BQ BR BS BT BV BW BY BZ ' +
  'CA CC CD CF CG CH CI CK CL CM CN CO CR CU CV CW CX CY CZ DE DJ DK DM DO DZ EC EE EG EH ER ES ET FI FJ FK FM FO FR ' +
  'GA GB GD GE GF GG GH GI GL GM GN GP GQ GR GS GT GU GW GY HK HM HN HR HT HU ID IE IL IM IN IO IQ IR IS IT JE JM JO JP ' +
  'KE KG KH KI KM KN KP KR KW KY KZ LA LB LC LI LK LR LS LT LU LV LY MA MC MD ME MF MG MH MK ML MM MN MO MP MQ MR MS MT ' +
  'MU MV MW MX MY MZ NA NC NE NF NG NI NL NO NP NR NU NZ OM PA PE PF PG PH PK PL PM PN PR PS PT PW PY QA RE RO RS RU RW ' +
  'SA SB SC SD SE SG SH SI SJ SK SL SM SN SO SR SS ST SV SX SY SZ TC TD TF TG TH TJ TK TL TM TN TO TR TT TV TW TZ UA UG ' +
  'UM US UY UZ VA VC VE VG VI VN VU WF WS XK YE YT ZA ZM ZW'
).split(' ');

/** Quick picks, with the short labels from the design. */
export const QUICK_COUNTRIES: ReadonlyArray<readonly [code: string, label: string]> = [
  ['NL', 'Nederland'],
  ['BE', 'België'],
  ['DE', 'Duitsland'],
  ['GB', 'VK'],
  ['US', 'VS'],
  ['PL', 'Polen'],
  ['JP', 'Japan'],
];

const SHORT: Record<string, string> = Object.fromEntries(QUICK_COUNTRIES);

let names: Intl.DisplayNames | null = null;

export function countryName(code: string): string {
  if (SHORT[code]) return SHORT[code];
  try {
    names ??= new Intl.DisplayNames(['nl'], { type: 'region' });
    return names.of(code) ?? code;
  } catch {
    return code;
  }
}

/** Long name, for the search list (VK -> Verenigd Koninkrijk). */
export function countryLongName(code: string): string {
  try {
    names ??= new Intl.DisplayNames(['nl'], { type: 'region' });
    return names.of(code) ?? code;
  } catch {
    return code;
  }
}

/** The design writes the United Kingdom as UK, not GB. */
export function countryCode(code: string): string {
  return code === 'GB' ? 'UK' : code;
}
